import axios from 'axios';

axios.defaults.timeout = 5000;
axios.defaults.baseURL = process.env.VUE_APP_BASE_API || '';

var _token;

// 请求拦截
axios.interceptors.request.use(
    config => {
        if (_token) {
            config.headers.authorization = _token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)

// 响应拦截
axios.interceptors.response.use(
    response => {
       
        if (response.data.code === 0) {
            return response.data.data;
        } else if (response.data.code === 422) {
            console.error(`${response.data.code} --> ${response.data.messages}`);
            return Promise.reject(response.data.data);
        } else {
            console.error(`${response.data.code} --> ${response.data.messages}`);
            return Promise.reject(response.data);
        }
    },
    error => {
        console.error(`${error.response}`);
        return Promise.reject(error);
    }
)

const http = {
    // 封装get请求
    get(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params
            }).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // 封装post请求
    post(url, data = {}) {
        return new Promise((resolve, reject) => {
//          url = '/api' + url;
            axios.post(url, data)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                })
        })
    }
}

export default http

export function setToken(token) {
    _token = token;
}